import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "form-field center" }
const _hoisted_3 = { class: "form-field" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "Note", -1)
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "col"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Adding Charge ")
const _hoisted_8 = {
  key: 1,
  class: "col"
}

import { ref } from "vue";
import BaseModal from "@/components/BaseModal.vue";
import BaseSpinner from "@/components/BaseSpinner.vue";

export default /*#__PURE__*/_defineComponent({
  props: {
  name: {
    type: String,
    required: true,
  },
  customerId: {
    type: String,
    required: true,
  },
  feeId: {
    type: String,
    required: true,
  },
  type: {
    type: String,
    required: true,
  },
  amount: {
    type: String,
    required: true,
  },
},
  emits: ["modalClosed", "fee"],
  setup(__props, { emit }) {

const props = __props

const formSubmitting = ref(false);
const note = ref("");


const formFields = ref({
  id: ref(props.feeId),
  quantity: ref(1),
  amount: ref(props.amount),
  description: ref(props.name),
  note: note.value,
});
const formFieldsService = ref({
  service_id: ref(props.feeId),
  amount: ref(props.amount),
  description: ref(props.name),
  note: note.value,
});
async function submitForm() {
  if (props.type == "service") {
    formFieldsService.value.note = note.value;

    emit("fee", formFieldsService.value);
  } else {
    formFields.value.note = note.value;
    emit("fee", formFields.value);
  }
  emit("modalClosed");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    ref: "modalRef",
    onModalClosed: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('modalClosed')))
  }, {
    header: _withCtx(() => [
      _createElementVNode("h2", null, _toDisplayString(__props.name), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _withModifiers(submitForm, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", null, "$" + _toDisplayString(__props.amount), 1),
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((note).value = $event)),
              required: "",
              type: "text"
            }, null, 512), [
              [_vModelText, note.value]
            ])
          ]),
          _createElementVNode("button", {
            disabled: formSubmitting.value,
            type: "submit",
            class: "btn btn-text"
          }, [
            (formSubmitting.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(BaseSpinner)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, "Add Charge"))
          ], 8, _hoisted_5)
        ])
      ], 40, _hoisted_1)
    ]),
    _: 1
  }, 512))
}
}

})